import workflowTypes from './types';

// Fetch Workflows
export const fetchWorkflows = (payload={page:0, size:10}) => ({
  type: workflowTypes.FETCH_WORKFLOWS_REQUEST,
  payload,
});
export const fetchWorkflowsSuccess = (payload) => ({
  type: workflowTypes.FETCH_WORKFLOWS_SUCCESS,
  payload,
});
export const fetchWorkflowsFailure = (payload) => ({
  type: workflowTypes.FETCH_WORKFLOWS_FAILURE,
  payload,
});

// Create Workflow
export const createWorkflows = (payload, cb = () => null) => ({
  type: workflowTypes.CREATE_WORKFLOWS_REQUEST,
  payload: payload,
  cb
});
export const createWorkflowsSuccess = (payload) => ({
  type: workflowTypes.CREATE_WORKFLOWS_SUCCESS,
  payload,
});
export const createWorkflowsFailure = (payload) => ({
  type: workflowTypes.CREATE_WORKFLOWS_FAILURE,
  payload,
});

// EDIT Workflow
export const editWorkflows = (id, payload, cb = () => null) => ({
  type: workflowTypes.EDIT_WORKFLOWS_REQUEST,
  payload: payload,
  cb,
  id
});
export const editWorkflowsSuccess = (payload) => ({
  type: workflowTypes.EDIT_WORKFLOWS_SUCCESS,
  payload,
});
export const editWorkflowsFailure = (payload) => ({
  type: workflowTypes.EDIT_WORKFLOWS_FAILURE,
  payload,
});

// Delete Workflow
export const deleteWorkflows = (id, cb = () => null) => ({
  type: workflowTypes.DELETE_WORKFLOWS_REQUEST,
  cb,
  id
});
export const deleteWorkflowsSuccess = (payload) => ({
  type: workflowTypes.DELETE_WORKFLOWS_SUCCESS,
  payload,
});
export const deleteWorkflowsFailure = (payload) => ({
  type: workflowTypes.DELETE_WORKFLOWS_FAILURE,
  payload,
});
